// extracted by mini-css-extract-plugin
module.exports = {"root":"JMHZvW","sliderWrapper":"QxZH_L","arrowContainer":"eGz2j5","arrow":"sKXgnt"};